export const HEX_DIGIT_MAP = {
    0: 0x200b,
    1: 0x200c,
    2: 0x200d,
    3: 0x2062,
    4: 0x2063,
    5: 0x2060,
    6: 0xfeff,
    7: 0x2061,
    8: 0x1d173,
    9: 0x1d174,
    a: 0x1d175,
    b: 0x1d176,
    c: 0x1d177,
    d: 0x1d178,
    e: 0x1d179,
    f: 0x1d17a,
};
